import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { NimbusPermission } from '@nimbus-global/features/permissions/models/enums/nimbus-permission.enum';
import { UserPermissionsService } from '@nimbus-global/features/permissions/services/domain/user-permissions.service';
import { IOrganizationUnitSelectListItemViewModel } from '@nimbus-global/features/shared/services/api/organization-unit/domain/i-organization-unit-select-list-item.view-model';
import { ToOrganizationUnitSelectListModelMapper } from '@nimbus-global/features/shared/services/api/organization-unit/domain/to-organization-unit-select-list-model.mapper';
import { OrganizationUnitTenantCacheService } from '@nimbus-global/features/shared/services/api/organization-unit/organization-unit-tenant-cache.service';

@Injectable({ providedIn: 'root' })
export class TenantOrganizationUnitLookupService {
  public constructor(
    private readonly tenantCache: OrganizationUnitTenantCacheService,
    private readonly userPermissionsService: UserPermissionsService,
  ) {}

  public getOrganizationUnits(
    tenantId: string,
    permissions: NimbusPermission[],
    includedIds: string[] = [],
  ): Observable<IOrganizationUnitSelectListItemViewModel[]> {
    return this.tenantCache.getOrganizationUnits(tenantId).pipe(
      switchMap((organizationUnits) =>
        this.userPermissionsService
          .havePermissions(
            permissions,
            organizationUnits.map((ou) => ou.id),
          )
          .pipe(
            take(1),
            map((assignedPermissions) => organizationUnits.filter((ou) => assignedPermissions[ou.id] || includedIds.includes(ou.id))),
          ),
      ),
    );
  }

  public getOrganizationUnitWithParents(
    tenantId: string,
    organizationUnitId: string,
    permissions: NimbusPermission[],
  ): Observable<IOrganizationUnitSelectListItemViewModel[]> {
    return this.getOrganizationUnits(tenantId, permissions).pipe(
      map((organizationUnits) =>
        new ToOrganizationUnitSelectListModelMapper().getOrganizationUnitWithParents(organizationUnits, organizationUnitId),
      ),
    );
  }
}
